import styled from 'styled-components'
import { t } from 'ttag'

import { Heading } from '@h2/components/typography/heading'
import { CareerHubIcon } from '@h2/components/icons/careerHub'

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  grid-area: hdr;
`
const Header = () => (
  <Wrap>
    <CareerHubIcon height="40px" width="40px" />
    <Heading level="4" removeMargins={true}>
      {t`CareerHub Overview`}
    </Heading>
  </Wrap>
)

export { Header }
